<mat-icon *ngIf="isMatrixDelete">
    <a href="javascript:void(0)" (click)="open(mymodal_delete)" #tooltip="matTooltip" matTooltip="Delete" [matTooltipPosition]="tooltip_position"
        >delete_forever</a
    >
</mat-icon>

<!-- delete modal open -->
<ng-template #mymodal_delete let-modal>
    <div class="modal-header">
        <h4 i118n>Confirm Matrix Delete</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable">
        <div class="row">
            <div class="col-md-12" style="padding: 15px">
                <p i118n>Are you sure you want to permanently remove this joint matrix and its entires?</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="btnDeleteMatrix()">Ok</button>
        <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
    </div>
</ng-template>
